import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    fetchJobsPending: false,
    jobs: {
      draft: [],
      unpublishable: [],
      active: [],
      activeWithRestricted: [],
      trashed: [],
    },
    fetchJobPending: false,
    job: {},
    storeJobPending: false,
    deleteJobPending: false,
  },
  actions,
  mutations,
};
